import * as React from "react";
import throttle from "../../../utils/throttle";
import { LinkBox, NavContainer, ArrowBox, ShowBox } from "./style";
import { getPxByRem } from "../../utils";
const NAVHEIGHT = 3.1;
const arrowPoster = "https://i.ezbuy.sg/FipFPHV0jCuBeo8YBQgig1oJtL6m";
const Navigation = (props) => {
    const { positionId, texts, navFixed, stickToTop = 0 } = props;
    const navRef = React.useRef(null);
    const [showList, setShowList] = React.useState(false);
    const [activeItem, setTabIndex] = React.useState(0);
    const [scrollFixed, setScrollFixed] = React.useState(false);
    React.useEffect(() => {
        if (navFixed) {
            window.addEventListener("scroll", throttle(scrollObserver, 30));
        }
        return () => {
            window.addEventListener("scroll", throttle(scrollObserver, 30));
        };
    }, []);
    const scrollObserver = (event) => {
        var _a;
        const target = event.target;
        if (navFixed && navRef) {
            const scrollTop = (target ? target.documentElement.scrollTop : false) ||
                window.pageYOffset ||
                (target ? target.body.scrollTop : 0);
            if (scrollTop > ((_a = navRef === null || navRef === void 0 ? void 0 : navRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop)) {
                setScrollFixed(true);
                return;
            }
            setScrollFixed(false);
        }
    };
    const clickNavItem = (link = "", nextTab) => {
        setTabIndex(nextTab);
        const linkID = link.substr(1);
        let dom = document.getElementById(linkID);
        const hasSelfTop = navFixed ? getPxByRem(NAVHEIGHT) : 0;
        const top = (dom === null || dom === void 0 ? void 0 : dom.getBoundingClientRect().top) - getPxByRem(stickToTop) - hasSelfTop;
        window.scrollBy(0, top);
        setShowList(false);
    };
    const RenderItem = () => {
        return (texts || []).map((ele, index) => (React.createElement("a", { key: `${ele.link}${index}`, "data-index": activeItem, style: index === activeItem
                ? {
                    fontWeight: 600,
                    color: "#3e82f7",
                    borderBottom: "2px solid",
                }
                : {}, onClick: () => clickNavItem(ele.link, index) }, (ele === null || ele === void 0 ? void 0 : ele.content) || (ele === null || ele === void 0 ? void 0 : ele.text))));
    };
    return (React.createElement("section", { "data-id": positionId, id: positionId, ref: navRef, style: {
            minHeight: `${NAVHEIGHT}rem`,
        } },
        React.createElement(NavContainer, { style: scrollFixed ? { position: "fixed", top: `${stickToTop}rem` } : {} },
            showList ? (React.createElement(ShowBox, null, RenderItem())) : (React.createElement(LinkBox, null, RenderItem())),
            React.createElement(ArrowBox, { isUp: showList, onClick: () => setShowList(!showList) },
                React.createElement("img", { src: arrowPoster })))));
};
export default Navigation;
